<div class="icon-bar {{ scale }}">
  <div class="icon {{ hideIcon.includes(icon.icon) ? 'hidden' : '' }}" *ngFor="let icon of icons">
    <img [src]="icon.icon" [alt]="icon.alt" [title]="icon.title" (error)="iconNotFound(icon.icon)"/>
    <div class="description">
      {{ icon.description }}
    </div>
  </div>
</div>
